import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=fd06f8a6&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=fd06f8a6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd06f8a6",
  null
  
)

export default component.exports